import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

const services = [
  {
    anchorKey: "home.anchorSliding",
    descKey: "home.servicesSlidingDesc",
    icon: "ri-door-open-line",
    image: "https://readdy.ai/api/search-image?query=A%20sliding%20glass%20patio%20door%20roller%20track%20being%20serviced%20by%20a%20repair%20technician%2C%20close-up%20professional%20photo%20showing%20worn%20rollers%20and%20clean%20tracks%20on%20a%20residential%20home%20in%20Miami%2C%20warm%20daylight%2C%20clean%20modern%20aesthetic&width=400&height=240&seq=svc1&orientation=landscape",
    imageAlt: "home.svc1Alt",
    path: "/sliding-door-repair",
    titleKey: "home.servicesSliding",
  },
  {
    anchorKey: "home.anchorGlass",
    descKey: "home.servicesGlassDesc",
    icon: "ri-focus-3-line",
    image: "https://readdy.ai/api/search-image?query=A%20professional%20window%20glass%20replacement%20technician%20carefully%20installing%20a%20new%20pane%20into%20an%20existing%20residential%20window%20frame%2C%20close-up%20shot%2C%20Miami%20home%20exterior%20background%2C%20clean%20daylight&width=400&height=240&seq=svc2&orientation=landscape",
    imageAlt: "home.svc2Alt",
    path: "/glass-replacement",
    titleKey: "home.servicesGlass",
  },
  {
    anchorKey: "home.anchorHardware",
    descKey: "home.servicesHardwareDesc",
    icon: "ri-tools-line",
    image: "https://readdy.ai/api/search-image?query=Close-up%20of%20assorted%20window%20hardware%20parts%20including%20handles%2C%20locks%2C%20hinges%2C%20and%20cranks%20laid%20out%20neatly%20on%20a%20workbench%20for%20repair%2C%20professional%20lighting%2C%20clean%20organized%20workspace&width=400&height=240&seq=svc3&orientation=landscape",
    imageAlt: "home.svc3Alt",
    path: "/window-hardware-repair",
    titleKey: "home.servicesHardware",
  },
  {
    anchorKey: "home.anchorWeather",
    descKey: "home.servicesWeatherDesc",
    icon: "ri-shield-check-line",
    image: "https://readdy.ai/api/search-image?query=A%20technician%20installing%20weatherstripping%20seal%20on%20a%20residential%20window%20frame%2C%20close-up%20detail%20shot%20showing%20rubber%20seal%20being%20applied%2C%20clean%20professional%20work%2C%20warm%20daylight&width=400&height=240&seq=svc4&orientation=landscape",
    imageAlt: "home.svc4Alt",
    path: "/weatherstripping-sealing",
    titleKey: "home.servicesWeather",
  },
  {
    anchorKey: "home.anchorMaint",
    descKey: "home.servicesMaintDesc",
    icon: "ri-brush-line",
    image: "https://readdy.ai/api/search-image?query=A%20professional%20window%20cleaning%20and%20maintenance%20service%20being%20performed%20on%20a%20modern%20residential%20home%2C%20clean%20sparkling%20windows%2C%20Miami%20tropical%20landscaping%20in%20background%2C%20bright%20daylight&width=400&height=240&seq=svc5&orientation=landscape",
    imageAlt: "home.svc5Alt",
    path: "/window-cleaning-maintenance",
    titleKey: "home.servicesMaint",
  },
  {
    anchorKey: "home.anchorBoardup",
    descKey: "home.servicesBoardupDesc",
    icon: "ri-hammer-line",
    image: "https://readdy.ai/api/search-image?query=Emergency%20board-up%20service%20securing%20a%20broken%20residential%20window%20with%20plywood%20panels%2C%20professional%20repair%20work%20at%20dusk%2C%20safety%20and%20urgency%2C%20Miami%20home%20exterior&width=400&height=240&seq=svc6&orientation=landscape",
    imageAlt: "home.svc6Alt",
    path: "/emergency-board-up",
    titleKey: "home.servicesBoardup",
  },
];

export default function ServicesSection() {
  const { t } = useLanguage();

  return (
    <section className="w-full bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black text-secondary mb-4">
            {t("home.servicesTitle")}
          </h2>
          <p className="text-sm md:text-base text-[#374151] max-w-[720px] mx-auto">
            {t("home.servicesSub")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <Link
              key={service.path}
              to={service.path}
              className="group block bg-white rounded-xl border-t-4 border-primary shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 overflow-hidden"
            >
              {/* Image */}
              <div className="w-full h-[180px] overflow-hidden">
                <img
                  src={service.image}
                  alt={t(service.imageAlt) as string}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  width={400}
                  height={240}
                />
              </div>
              <div className="p-7">
                <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-lg mb-4">
                  <i className={`${service.icon} text-2xl text-primary`} />
                </div>
                <h3 className="text-xl font-bold text-secondary mb-2">
                  {t(service.titleKey)}
                </h3>
                <p className="text-sm text-[#374151] leading-relaxed mb-4">
                  {t(service.descKey)}
                </p>
                <div className="flex items-center gap-1 text-sm font-bold text-primary">
                  {t(service.anchorKey)}
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}